import styled from 'styled-components';

export const ContactMyAdminWrapper = styled.div`
  position: relative;
  gap: 5px;
`;
